import { render, staticRenderFns } from "./taskInfo.vue?vue&type=template&id=fe52906a&"
import script from "./taskInfo.vue?vue&type=script&lang=js&"
export * from "./taskInfo.vue?vue&type=script&lang=js&"
import style0 from "./taskInfo.vue?vue&type=style&index=0&id=fe52906a&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports